import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect, RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { ArticlesStore } from '../../../stores/ArticlesStore';
import { BodyLayout } from '../../Layout/BodyLayout';
import { SideMenu } from '../../SideMenu/SideMenu';
import { CategoriesStore } from 'stores/CategoriesStore';
import { toast } from 'react-toastify';
import { localizedStrings } from 'localizedStrings';

type PathParamsType = {
  projectId: string;
  categoryId: string;
};

type Props = RouteComponentProps<PathParamsType> & {
  articlesStore?: ArticlesStore;
  categoriesStore?: CategoriesStore;
};

@inject('categoriesStore')
@observer
class CategoryShortUrlComponent extends React.Component<Props> {
  componentDidMount(): void {
    document.title = `${this.props.match.params.projectId} [${this.props.match.params.categoryId}]`;
  }
  componentDidUpdate(): void {
    document.title = `${this.props.match.params.projectId} [${this.props.match.params.categoryId}]`;
  }
  render(): React.ReactNode {
    const { categoriesStore, match } = this.props;
    // eslint-disable-next-line
    const categoryToRoute = categoriesStore!.getCategoryById(match.params.categoryId);

    const sideMenu = categoryToRoute ? (
      <SideMenu
        categoryId={
          // eslint-disable-next-line
          categoryToRoute.id!
        }
      />
    ) : (
      <div> ...loading side menu </div>
    );

    if (categoryToRoute) {
      const url = `/${match.params.projectId}/category/${categoryToRoute.id}/`;
      return <Redirect to={url} />;
    }
    if (!categoryToRoute) {
      toast.warn(localizedStrings.category.notFoundWarning);
      const url = `/${match.params.projectId}/`;
      return <Redirect to={url} />;
    }

    return <BodyLayout sideMenu={sideMenu} content={<div> ... loading article content </div>} />;
  }
}

export const CategoryShortUrl = withRouter(CategoryShortUrlComponent);
